import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';
import { primaryShadow } from '@hivebrite/design-system/Theme';

const LoadingItem = () => (
  <LoadingTemplateWrapper>
    <Loader size={32} />
  </LoadingTemplateWrapper>
);

export default LoadingItem;

const LoadingTemplateWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  bg: 'white',
  flexDirection: 'column',
  height: '350px',
  justifyContent: 'center',
}))`
  border-radius: 10px;
  ${primaryShadow}
`;
